import { switchAccount } from '~/lib/account';

import AddTeamIcon from './AddTeamIcon.svg';
import ManageTeamGo from './ManageTeamGo.svg';
import styles from './styles';
import Team from './Team.svg';
import TeamSelected from './TeamSelected.svg';

const AccountSwitch = ({ classes, accounts, currentAccountId }) => (
  <div className={classnames(classes.section, classes.teams)}>
    <ul className={classes.accounts}>
      {accounts.map((account) => (
        <li
          className={classnames(classes.account, {
            [classes.accountSelected]: currentAccountId === account.id,
          })}
          key={account.id}
        >
          <button
            className={classes.option}
            onClick={() => {
              if (currentAccountId !== account.id) {
                switchAccount(account.id);
              } else {
                window.open('https://dashboard.clearbit.com/team?bar=false');
              }
            }}
          >
            {currentAccountId === account.id ? (
              <TeamSelected
                className={classes.optionIcon}
                style={{ width: 16, height: 16 }}
              />
            ) : (
              <Team
                className={classes.optionIcon}
                style={{ width: 16, height: 16 }}
              />
            )}

            <div className={classes.name}>
              <span className={classes.teamName}>{account.name}</span>
              {currentAccountId === account.id && (
                <span className={classes.manageTeamLink}>
                  Manage team
                  <ManageTeamGo />
                </span>
              )}
            </div>

            {currentAccountId === account.id && (
              <div className={classes.currentTag}>Current</div>
            )}
          </button>
        </li>
      ))}
      <li className={classes.account}>
        <div className={classes.name}>
          <a
            className={classes.option}
            href="https://dashboard.clearbit.com/team/new"
            rel="noopener noreferrer"
            target="_blank"
          >
            <AddTeamIcon className={classes.createTeamIcon} />
            <span className={classes.teamName}>Create new team</span>
          </a>
        </div>
      </li>
    </ul>
  </div>
);

AccountSwitch.propTypes = {
  accounts: PropTypes.array,
  classes: PropTypes.object.isRequired,
  currentAccountId: PropTypes.string,
};

export default withStyles(styles)(AccountSwitch);
